import React from 'react';
import { IonPage } from '@ionic/react';
import BasePageWithHeader from '../components/BasePageWithHeader';
import styles from './testpage.module.scss';
import { IonButton, IonIcon } from '@ionic/react';
import { chevronBack, search } from 'ionicons/icons';
import baseStyles from '../components/BasePageWithHeader.module.scss';
import { useTranslation } from 'react-i18next';
// no card in this simple test page


// test page previously injected page-specific styles here; styles are now handled by `BasePageWithHeader.module.scss`

const TestPage: React.FC = () => {
  const { t } = useTranslation();
  // Test page delegates scroll handling to BasePageWithHeader; no hooks required here
    return (
      <>
        <IonPage>
          <BasePageWithHeader 
            title={t('pages.testpage.testPage')}
            toolbarClassName={styles.card}
          startButtons={
            <IonButton className={baseStyles.backButton} onClick={() => history.back()} shape='round' aria-label={t('pages.testpage.back')}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          }
          endButtons={
            <IonButton className={baseStyles.searchButton} onClick={() => alert('search')} shape='round' aria-label={t('pages.testpage.search')}>
              <IonIcon icon={search} />
            </IonButton>
          }
          >
          </BasePageWithHeader>
        </IonPage>
      </>
    );
};

export default TestPage;